import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import MainLayout from './MainLayout';

const Authentication = () => {
    const accessToken = useSelector((state) => state.auth.accessToken);
    return accessToken ? <MainLayout /> : <Navigate to={'login'} replace />;
};

export default Authentication;